// extracted by mini-css-extract-plugin
export default {"nav":"styles_nav__lDl+2","all":"styles_all__fSpYU","activeNav":"styles_activeNav__W2R5z","envLabel":"styles_envLabel__0+uMi"};